<template #content>
    <Dialog
        :visible="visible"
        @update:visible="updateVisible"
        @show="onShow"
        @hide="onHide"
        class="w-11 lg:w-6"
        modal >
        <template #header>
            <div class="flex justify-content-between flex-wrap w-full">
                <div>
                    <span class="font-bold">Cotação</span>
                </div>

                <div class="flex justify-content-end gap-1">
                    <Button
                        v-if="form.id"
                        label="Log"
                        severity="secondary"
                        icon="pi pi-history"
                        size="small"
                        class="flex align-items-center justify-content-center"
                        @click="openLogForm"
                        :loading="isLoading" />
                </div>
            </div>
        </template>
        <form @submit.prevent="onSubmit(form)">

            <div class="w-full">
                <div class="field mt-4 flex gap-2">
                    <div class="w-6">
                        <InputGroup>
                            <FloatLabel>
                                <InputText id="provedor_id" v-model="form.provedor" class="w-full" readonly />
                                <label for="provedor_id">Provedor<span class="text-red-500">*</span></label>
                            </FloatLabel>
                            <Button icon="pi pi-search" severity="info" @click="visibleProvedorListaSelect = true"></Button>
                            <Button icon="pi pi-times" severity="danger" @click="clearProvedor"></Button>
                        </InputGroup>
                        <div class="text-xs text-red-500">{{ errors['provedor_id'] }}</div>
                    </div>

                    <div class="w-3">
                        <InputGroup>
                            <FloatLabel>
                                <InputNumber v-model="form.sla" fluid />
                                <label>SLA</label>
                            </FloatLabel>
                            <InputGroupAddon>Horas</InputGroupAddon>
                        </InputGroup>
                        <div class="text-xs text-red-500">{{ errors['site'] }}</div>
                    </div>
                    <div class="w-3 flex align-content-center">
                        <div class="flex align-items-center gap-2">
                            <Checkbox v-model="form.sla_nbd" inputId="cot_sla_nbd" :trueValue="1" :falseValue="0" binary />
                            <label for="cot_sla_nbd">NBD</label>
                        </div>
                    </div>
                </div>

                <div class="field mt-4 flex gap-2">
                    <div class="w-4">
                        <InputGroup>
                            <InputGroupAddon>R$</InputGroupAddon>
                            <FloatLabel>
                                <InputNumber id="valor_referencia" v-model="form.valor" :minFractionDigits="2" :maxFractionDigits="5" fluid />
                                <label for="valor">Valor<span class="text-red-500">*</span></label>
                            </FloatLabel>
                        </InputGroup>
                        <div class="text-xs text-red-500">{{ errors['valor'] }}</div>
                    </div>
                    <div class="w-4">
                        <InputGroup>
                            <InputGroupAddon>R$</InputGroupAddon>
                            <FloatLabel>
                                <InputNumber id="valor_com_desconto" v-model="form.valor_com_desconto" :minFractionDigits="2" :maxFractionDigits="5" fluid />
                                <label for="valor_com_desconto">Valor com Desconto</label>
                            </FloatLabel>
                        </InputGroup>
                        <div class="text-xs text-red-500">{{ errors['valor_com_desconto'] }}</div>
                    </div>
                    <div class="w-4">
                        <InputGroup>
                            <InputGroupAddon>R$</InputGroupAddon>
                            <FloatLabel>
                                <InputNumber id="valor_instalacao" v-model="form.valor_instalacao" :minFractionDigits="2" :maxFractionDigits="5" fluid />
                                <label for="valor_instalacao">Valor Instalação</label>
                            </FloatLabel>
                        </InputGroup>
                        <div class="text-xs text-red-500">{{ errors['valor_instalacao'] }}</div>
                    </div>
                </div>

                <div class="field mt-4 flex gap-2">
                    <div class="w-6">
                        <FloatLabel>
                            <InputText id="velocidade" v-model="form.velocidade" class="w-full" />
                            <label for="velocidade">Velocidade</label>
                        </FloatLabel>
                        <div class="text-xs text-red-500">{{ errors['velocidade'] }}</div>
                    </div>

                    <div class="w-6">
                        <FloatLabel>
                            <InputText id="tipo_link" v-model="form.tipo_link" class="w-full" />
                            <label for="tipo_link">Tipo de Link</label>
                        </FloatLabel>
                        <div class="text-xs text-red-500">{{ errors['tipo_link'] }}</div>
                    </div>
                </div>

                <div class="field mt-4 flex gap-2">
                    <div class="w-12">
                        <FloatLabel>
                            <Textarea id="observacoes" v-model="form.observacoes" class="w-full" rows="5" />
                            <label for="observacoes">Observações</label>
                        </FloatLabel>
                        <div class="text-xs text-red-500">{{ errors['observacoes'] }}</div>
                    </div>
                </div>

                <ProvedorListaSelect :visible="visibleProvedorListaSelect" :permissoes="permissoes" @close="visibleProvedorListaSelect = false" @select="selectProvedor" />
            </div>

            <div class="flex justify-content-between flex-wrap">
                <div class="flex justify-content-start flex-wrap gap-1">
                    <div class="text-xs">
                        <span class="text-red-500">*</span> obrigatório<br>
                    </div>
                </div>
                <div class="flex justify-content-end gap-1">
                    <Button
                        :disabled="permissoes.COTACAO_EDITAR"
                        type="submit"
                        label="Salvar"
                        severity="success"
                        icon="pi pi-save"
                        size="small"
                        class="flex align-items-center justify-content-center"
                        :loading="isLoading" />
                    <Button
                        label="Fechar"
                        severity="warn"
                        icon="pi pi-times"
                        size="small"
                        @click="updateVisible(false)"
                        class="flex align-items-center justify-content-center"
                        :loading="isLoading" />
                </div>
            </div>
        </form>
        <LogForm :visible="visibleLogForm" table="cotacoes" :tableId="form.id" @close="this.visibleLogForm=false" />
    </Dialog>
</template>
<script>
import Dialog from 'primevue/dialog';
import FloatLabel from 'primevue/floatlabel';
import InputText from 'primevue/inputtext';
import Select from 'primevue/select';
import InputMask from 'primevue/inputmask';
import Checkbox from 'primevue/checkbox';
import AutoComplete from 'primevue/autocomplete';
import DatePicker from 'primevue/datepicker';
import InputNumber from 'primevue/inputnumber';
import Textarea from 'primevue/textarea';
import Button from 'primevue/button';
import InputGroup from 'primevue/inputgroup';
import InputGroupAddon from 'primevue/inputgroupaddon';
import Panel from 'primevue/panel';

import Cotacao from '@/service/cotacao.js';

import ProvedorListaSelect from '@/page/provedor/ListaSelect.vue';
import LogForm from '@/components/LogForm.vue'

export default {
    components: { Dialog,
        FloatLabel,
                  InputGroup,
                  InputGroupAddon,
                  Button,
                  InputText,
                  InputMask,
                  Select,
                  Textarea,
                  AutoComplete,
                  Checkbox,
                  DatePicker,
                  InputNumber,
                  Panel,

                  ProvedorListaSelect,
                  LogForm,
                },
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        data: {
            type: Object,
            default: {}
        },
        permissoes: {},
    },
    emits: ['save','close'],
    data() {
        return {
            form: {},
            errors: {},
            isLoading: false,

            visibleProvedorListaSelect: false,
            visibleLogForm: false,
        }
    },
    methods: {
        selectProvedor(provedor) {
            this.form.provedor = provedor.nome;
            this.form.provedor_id = provedor.id;
        },
        clearProvedor() {
            this.form.provedor = null;
            this.form.provedor_id = null;
        },
        onShow() {
            this.form = Cotacao.parse({...this.data});
        },
        onHide() {
            this.form = {};
        },
        openLogForm() {
            this.visibleLogForm = true;
        },
        updateVisible(visible) {
            this.$emit('close', visible);
        },
        save(form) {
            if(form.id) {
                return Cotacao.update(form.id,form);
            }
            return Cotacao.create(form);
        },
        onSubmit(form) {
            this.errors = {};
            this.sendSubmit(form);
        },
        sendSubmit(form) {
            this.errors = {};
            this.isLoading = true;

            this.save(form)
                .then(response => {
                    this.$toast.add({ severity: 'success', summary: 'Sucesso', detail: 'Seus dados foram salvos com sucesso.', life: 3000 });
                    this.form = Cotacao.parse(response.data.data);
                    this.$emit('save');
                    this.$emit('close');
                })
                .catch(error => {
                    if(error.response) {
                        let err = error.response.data;

                        if(err.erros && err.erros.length) {
                            for(let i in err.erros) {
                                this.errors[i] = err.erros[i][0];
                            }
                            return;
                        }
                        if(error.response.data.msg) {
                            this.$toast.add({ severity: 'error', summary: 'Ops!', detail: error.response.data.msg, life: 5000 });
                            return;
                        }
                    }

                    this.$toast.add({ severity: 'error', summary: 'Ops!', detail: error.message, life: 5000 });
                })
                .finally(() => {
                    this.isLoading = false;
                });
        }
    }
}
</script>
